import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-primary-900 text-background-50" role="contentinfo">
      <div className="px-4 md:px-6 py-14 max-w-7xl mx-auto">
        {/* Top row: logo + desc */}
        <div className="flex flex-col sm:flex-row justify-between items-start gap-6 mb-12">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-accent-500 rounded-xl flex items-center justify-center">
              <i className="ri-fire-line text-xl text-background-50"></i>
            </div>
            <span className="font-heading text-2xl text-background-50">51吃瓜</span>
          </div>
          <p className="text-secondary-300/60 text-sm max-w-md leading-relaxed">
            聚合最新网红明星八卦、吃瓜爆料、黑料视频，一站式吃瓜平台。实时掌握网红明星塌房动态。
          </p>
        </div>

        {/* Middle: navigation columns */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-12">
          <div>
            <h4 className="text-background-50/80 font-medium text-sm mb-4">
              热门分类
            </h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 4).map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-secondary-300/60 text-sm hover:text-accent-400 transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="text-background-50/80 font-medium text-sm mb-4">
              更多分类
            </h4>
            <ul className="space-y-2.5">
              {categories.slice(4).map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-secondary-300/60 text-sm hover:text-accent-400 transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
              <li>
                <Link
                  to="/about"
                  className="text-secondary-300/60 text-sm hover:text-accent-400 transition-colors"
                >
                  关于我们
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="text-background-50/80 font-medium text-sm mb-4">
              热门标签
            </h4>
            <ul className="space-y-2.5">
              <li>
                <span className="text-secondary-300/60 text-sm cursor-pointer hover:text-accent-400 transition-colors">
                  顶流塌房
                </span>
              </li>
              <li>
                <span className="text-secondary-300/60 text-sm cursor-pointer hover:text-accent-400 transition-colors">
                  恋情曝光
                </span>
              </li>
              <li>
                <span className="text-secondary-300/60 text-sm cursor-pointer hover:text-accent-400 transition-colors">
                  深夜发文
                </span>
              </li>
              <li>
                <span className="text-secondary-300/60 text-sm cursor-pointer hover:text-accent-400 transition-colors">
                  大瓜预警
                </span>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="text-background-50/80 font-medium text-sm mb-4">
              关于
            </h4>
            <p className="text-secondary-300/50 text-sm leading-relaxed">
              &copy; 2026 51吃瓜网站
              <br />
              All rights reserved.
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="text-secondary-300/60 hover:text-accent-400 transition-colors text-lg" aria-label="微博" rel="nofollow">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="text-secondary-300/60 hover:text-accent-400 transition-colors text-lg" aria-label="微信" rel="nofollow">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="text-secondary-300/60 hover:text-accent-400 transition-colors text-lg" aria-label="抖音" rel="nofollow">
                <i className="ri-tiktok-line"></i>
              </a>
              <a href="#" className="text-secondary-300/60 hover:text-accent-400 transition-colors text-lg" aria-label="B站" rel="nofollow">
                <i className="ri-bilibili-line"></i>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-primary-700/50 pt-6 flex flex-col sm:flex-row justify-between items-center gap-3">
          <p className="text-secondary-300/40 text-xs">
            51吃瓜网站——聚合最新网红明星八卦、吃瓜爆料、黑料视频，一站式吃瓜平台
          </p>
          <div className="flex items-center gap-4 text-secondary-300/40 text-xs">
            <a href="#" className="hover:text-accent-400 transition-colors" rel="nofollow">隐私政策</a>
            <a href="#" className="hover:text-accent-400 transition-colors" rel="nofollow">使用条款</a>
            <a href="#" className="hover:text-accent-400 transition-colors" rel="nofollow">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}